import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d8cd514"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Modelo", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Marca", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Fipe", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Ano", -1))
const _hoisted_5 = { class: "d-flex gap-3" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger",
  style: {"font-size":"9px","display":"block"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fs-5" }, "Filtros", -1))
const _hoisted_8 = { class: "w-100 d-flex gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_FilterBase = _resolveComponent("FilterBase")!

  return (_openBlock(), _createBlock(_component_FilterBase, {
    id: "filtro-veiculo",
    subtitle: "Faça filtros e aprimore sua busca",
    hideFilter: false,
    staticModal: false,
    hideClose: false,
    activeModal: false,
    closeModal: _ctx.fecharModal,
    disabledClick: true,
    onSearch: _cache[16] || (_cache[16] = ($event: any) => (_ctx.buscar()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _hoisted_1,
        _withDirectives(_createElementVNode("input", {
          onKeyup: _cache[0] || (_cache[0] = (e) => e.key === 'Enter' && _ctx.buscar()),
          style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
          class: "p-2 mb-4 w-100",
          placeholder: "Digite...",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.veiculoFiltro.modelo) = $event))
        }, null, 544), [
          [_vModelText, _ctx.veiculoFiltro.modelo]
        ]),
        _hoisted_2,
        _createVNode(_component_el_select, {
          modelValue: _ctx.veiculoFiltro.marca,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.veiculoFiltro.marca) = $event)),
          multiple: "",
          filterable: "",
          "collapse-tags": "",
          placeholder: "Selecione um grupo",
          clearable: "",
          class: "w-100 mb-4"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.arrayMarcas, (marca) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: marca,
                value: marca
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(marca), 1)
                ]),
                _: 2
              }, 1032, ["label", "value"]))
            }), 256))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          onKeyup: _cache[3] || (_cache[3] = (e) => e.key === 'Enter' && _ctx.buscar()),
          style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
          class: "p-2 mb-4 w-100",
          placeholder: "Digite...",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.veiculoFiltro.fipe) = $event))
        }, null, 544), [
          [_vModelText, _ctx.veiculoFiltro.fipe]
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _withDirectives(_createElementVNode("input", {
            onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.verificaAno())),
            onInput: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.applyMask && _ctx.applyMask(...args))),
            onKeyup: _cache[7] || (_cache[7] = (e) => e.key === 'Enter' && _ctx.buscar()),
            style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
            class: "p-2 mb-4 w-100",
            placeholder: "Inicial...",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.veiculoFiltro.anoInicial) = $event))
          }, null, 544), [
            [_vModelText, _ctx.veiculoFiltro.anoInicial]
          ]),
          _withDirectives(_createElementVNode("input", {
            onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.verificaAno())),
            onInput: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.applyMask && _ctx.applyMask(...args))),
            onKeyup: _cache[11] || (_cache[11] = (e) => e.key === 'Enter' && _ctx.buscar()),
            style: {"border":"1.5px solid #DBDBDB","border-radius":"4px"},
            class: "p-2 mb-4 w-100",
            placeholder: "Final...",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.veiculoFiltro.anoFinal) = $event))
          }, null, 544), [
            [_vModelText, _ctx.veiculoFiltro.anoFinal]
          ])
        ]),
        (_ctx.mensagem)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.mensagem), 1))
          : _createCommentVNode("", true),
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          (_ctx.veiculoFiltro.comFiltro == null)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                variant: "secondary",
                class: "w-100 opacity-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Todos")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                onClick: _cache[13] || (_cache[13] = ()=> _ctx.veiculoFiltro.comFiltro = null),
                variant: "secondary",
                class: "w-100 opacity-25"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Todos")
                ]),
                _: 1
              })),
          (_ctx.veiculoFiltro.comFiltro == true)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                variant: "secondary",
                class: "w-100 opacity-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Com filtro")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 3,
                onClick: _cache[14] || (_cache[14] = ()=> _ctx.veiculoFiltro.comFiltro = true),
                variant: "secondary",
                class: "w-100 opacity-25"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Com filtro")
                ]),
                _: 1
              })),
          (_ctx.veiculoFiltro.comFiltro == false)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 4,
                variant: "secondary",
                class: "w-100 opacity-100"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sem filtro")
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_Button, {
                key: 5,
                onClick: _cache[15] || (_cache[15] = ()=> _ctx.veiculoFiltro.comFiltro = false),
                variant: "secondary",
                class: "w-100 opacity-25"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Sem filtro")
                ]),
                _: 1
              }))
        ])
      ])
    ]),
    _: 1
  }, 8, ["closeModal"]))
}